export const REDACTED = '[REDACTED]'

export const PRESERVED_KEYS = new Set([
  'trace_id',
  'span_id',
  'parent_span_id',
  'event_id',
  'replay_id',
  'profile_id',
  'public_key',
  'sample_rand',
  'sample_rate',
  'segment_id',
  'release',
  'dist',
])

const CARD_IIN = /^(?:4|5[1-5]|2[2-7]|3[47]|6(?:011|5|4[4-9])|3[0689])/
const BANKING_KEY = /rout|aba|bank/i

const MAX_NODES = 50000

const luhn = (digits) => {
  let sum = 0
  let double = false

  for (let i = digits.length - 1; i >= 0; i -= 1) {
    let digit = digits.charCodeAt(i) - 48
    if (double) {
      digit *= 2
      if (digit > 9) digit -= 9
    }
    sum += digit
    double = !double
  }

  return sum % 10 === 0
}

const aba = (digits) => (
  3 * (+digits[0] + +digits[3] + +digits[6])
  + 7 * (+digits[1] + +digits[4] + +digits[7])
  + (+digits[2] + +digits[5] + +digits[8])
) % 10 === 0

const RULES = [
  { pattern: /\bBearer\s+[A-Za-z0-9._~+/=-]+/gi },
  { pattern: /\beyJ[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{6,}/g },
  { pattern: /\b[0-9a-f]{32,}\b/gi },
  { pattern: /\b\d{3}-\d{2}-\d{4}\b/g },
  {
    pattern: /\b\d(?:[ -]?\d){12,18}\b/g,
    accept: (match) => {
      const digits = match.replace(/[^0-9]/g, '')
      return CARD_IIN.test(digits) && luhn(digits)
    },
  },
  {
    pattern: /\b\d{9}\b/g,
    bankingOnly: true,
    accept: aba,
  },
]

export const redactString = (value, key = '', context = '') => {
  if (typeof value !== 'string' || value === '') return value

  const banking = BANKING_KEY.test(key) || BANKING_KEY.test(context)
  let output = value

  for (const rule of RULES) {
    if (rule.bankingOnly && !banking) continue
    rule.pattern.lastIndex = 0
    output = output.replace(rule.pattern, (match) => (
      rule.accept && !rule.accept(match) ? match : REDACTED
    ))
  }

  return output
}

export const redactSecrets = (node) => {
  let visited = 0
  const seen = new WeakSet()

  const walk = (value, parentKey) => {
    if (!value || typeof value !== 'object') return
    if (seen.has(value)) return
    seen.add(value)

    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i += 1) {
        visited += 1
        if (visited > MAX_NODES) return
        const item = value[i]
        if (typeof item === 'string') value[i] = redactString(item, parentKey, item)
        else walk(item, parentKey)
      }
      return
    }

    for (const key of Object.keys(value)) {
      visited += 1
      if (visited > MAX_NODES) return
      if (PRESERVED_KEYS.has(key)) continue
      const item = value[key]
      if (typeof item === 'string') value[key] = redactString(item, key, item)
      else walk(item, key)
    }
  }

  try {
    walk(node, '')
  } catch (error) {
    return { event: node, complete: false, visited }
  }

  return { event: node, complete: visited <= MAX_NODES, visited }
}
